import { FelaCSS } from '../../fela/flowtypes';
import { SharedTypes } from './imagex';

interface PropTypes extends SharedTypes {
  paddingBottom: string;
  imageStyle?: FelaCSS;
  isLoaded: boolean;
}

interface StyleTypes {
  wrapper: FelaCSS;
  image: FelaCSS;
}

const styles = ({
  paddingBottom,
  style = {},
  imageStyle = {},
  isLoaded,
}: PropTypes): StyleTypes => ({
  wrapper: {
    position: 'relative',
    overflow: 'hidden',
    flexShrink: 0,
    paddingBottom,
    ...style,
  },

  image: {
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    width: '100%',
    position: 'absolute',
    opacity: isLoaded ? 1 : 0,
    transition: 'opacity 0.15s ease-in-out',
    ...imageStyle,
  },
});

export default styles;
